import { Component } from "@angular/core";

@Component({
    selector: 'app-port-calender',
    templateUrl: './port-calender.component.html',
    styleUrls: ['./port-calender.component.scss']
})
export class PortCalenderComponent {
}